import React from "react";
import { ArrowUpRight, Mail, MessageCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const WHATSAPP_URL = "https://wa.me/918796132668";
const EMAIL_URL = "mailto:askwinnb2b@gmail.com?subject=Talk%20to%20an%20AskWinn%20expert";

export default function ExpertContact({ children }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-md border-[--border-soft] bg-bone">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl font-medium">Talk to an expert</DialogTitle>
          <DialogDescription>Choose how you would like to reach the AskWinn team.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 pt-2">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-4 border border-[--border-soft] bg-white p-4 transition-colors hover:border-klein"
            data-testid="expert-contact-whatsapp"
          >
            <MessageCircle className="h-5 w-5 shrink-0 text-klein" aria-hidden="true" />
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold">WhatsApp</span>
              <span className="block text-xs text-[--muted-foreground]">+91 87961 32668</span>
            </span>
            <ArrowUpRight className="h-4 w-4 shrink-0" aria-hidden="true" />
          </a>
          <a
            href={EMAIL_URL}
            className="flex items-center gap-4 border border-[--border-soft] bg-white p-4 transition-colors hover:border-klein"
            data-testid="expert-contact-email"
          >
            <Mail className="h-5 w-5 shrink-0 text-klein" aria-hidden="true" />
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold">Email</span>
              <span className="block break-all text-xs text-[--muted-foreground]">askwinnb2b@gmail.com</span>
            </span>
            <ArrowUpRight className="h-4 w-4 shrink-0" aria-hidden="true" />
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}